import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["leftContent", "rightContent", "leftColor", "rightColor", "use"];
import { useTheme } from 'foundations-theming/utils';
import styled from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DEFAULT_LEFT_COLOR = 'fill-positive-pressed';
const DEFAULT_RIGHT_COLOR = 'fill-caution-pressed';
const StyledSection = styled.section.withConfig({
  displayName: "SplitColorSection__StyledSection",
  componentId: "m9aoxb-0"
})(({
  $colorScheme,
  $leftColor,
  $rightColor,
  $isTablet,
  theme: {
    color,
    space
  }
}) => ({
  color: $colorScheme === 'light' ? color['text-core-on-fill-default'] : 'auto',
  paddingBlock: $isTablet ? 0 : space['1100'],
  background: $isTablet ? 'none' : `linear-gradient(90deg, ${$leftColor} 0%, ${$leftColor} 50%, ${$rightColor} 50%, ${$rightColor} 100%)`
}));
const SplitColorSection = _ref => {
  let {
      leftContent,
      rightContent,
      leftColor = DEFAULT_LEFT_COLOR,
      rightColor = DEFAULT_RIGHT_COLOR,
      use = 'light'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    color
  } = useTheme();
  const {
    isTablet
  } = useMediaQuery();
  const resolvedLeftColor = color[leftColor];
  const resolvedRightColor = color[rightColor];
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledSection, Object.assign({
      $colorScheme: use,
      $isTablet: isTablet,
      $leftColor: resolvedLeftColor,
      $rightColor: resolvedRightColor
    }, props, {
      children: !isTablet ? /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          gap: 60,
          justify: "around",
          children: [/*#__PURE__*/_jsx(Box, {
            children: leftContent
          }), /*#__PURE__*/_jsx(Box, {
            children: rightContent
          })]
        })
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: leftColor,
          paddingBlock: "1100",
          children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
            children: /*#__PURE__*/_jsx(TFlex, {
              justify: "center",
              children: leftContent
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          backgroundColor: rightColor,
          paddingBlock: "1100",
          children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
            children: /*#__PURE__*/_jsx(TFlex, {
              justify: "center",
              children: rightContent
            })
          })
        })]
      })
    }))
  );
};
export default SplitColorSection;